// FE-BE contract enforcement — thrown when a Zod response schema fails to
// validate a backend response on the frontend side.
//
// Uses safeParse (not parse) so the frontend never throws raw ZodError to the
// user. Instead:
//   - Dev-time: console shows expected vs received diff via zodError.issues
//   - Prod: caught by error boundary → friendly "数据格式异常，请刷新重试"
import { z } from 'zod';
export class IngestContractError extends Error {
    name = 'IngestContractError';
    /** HTTP status from the response. */
    status;
    /** Zod validation error details (expected vs received). */
    zodError;
    /** Raw response body for debugging. */
    raw;
    constructor(status, zodError, raw) {
        const firstIssue = zodError.issues[0];
        const location = firstIssue
            ? `${firstIssue.path.join('.') || '(root)'}: ${firstIssue.message}`
            : zodError.message;
        super(`Contract violation (HTTP ${status}): ${location}`);
        this.status = status;
        this.zodError = zodError;
        this.raw = raw;
    }
}
//# sourceMappingURL=contract.js.map